import http from "@/utils/http";
import * as storeUrl from "@/recourses/urls/store";

const BASE_API_URL = import.meta.env.REACT_APP_BASE_API_URL;

const PICK_UP_STORE = "pick-up-stores/";

const getAvaliableStores = async (_key: string, lat: number, lng: number): Promise<AvaliableStoresAttr> => {
  const response = await http.get(storeUrl.storesAvailable(lat, lng), { isAuth: false });
  return response.data;
};

const getPickUpStores = async (): Promise<PickUpStore[]> => {
  const response = await http.get<PickUpStore[]>(`${BASE_API_URL}api/v1/${PICK_UP_STORE}`);
  return response.data;
};
const getInternationalCatalog = async ({
  storeId,
}: {
  storeId: number;
}): Promise<IInternationalCatalogResponse> => {
  const response = await http.get<IInternationalCatalogResponse>(storeUrl.catalogInternational(storeId));
  return response.data;
};

const getCoverageZones = async (): Promise<ICoverageZone[]> => {
  const response = await http.get<ICoverageZonesResponse>(storeUrl.coverageZones, { isAuth: false });
  return response.data?.payload ?? [];
};

export { getAvaliableStores, getPickUpStores, getInternationalCatalog, getCoverageZones };
